import { render } from "./CrudNegocio.vue?vue&type=template&id=5faaa505"
import script from "./CrudNegocio.vue?vue&type=script&lang=js"
export * from "./CrudNegocio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__